import { IMR as IMRComponent } from "@components/IMR/IMR";
import { SectionImpression } from "@components/SectionImpression/SectionImpression";
import { Typography } from "@jmc/solid-design-system/src/components/atoms/Typography/Typography";
import useJnjBranding from "@jmc/utils/hooks/useJnjBranding";
import { IMR } from "@types";
import classnames from "classnames";
import React from "react";

import style from "./style.module.scss";

interface FullIMRComponentPropsType {
    imr: IMR;
    marginXL: boolean;
    simple?: boolean;
}
export const FullIMRComponent = ({ imr, marginXL, simple = false }: FullIMRComponentPropsType): JSX.Element => {
    const { jnjFullBranded } = useJnjBranding();

    return jnjFullBranded ? (
        <SectionImpression name={"IMR"} position={1}>
            <div data-test-id="Shell.Body.iMR" className={classnames(style.imr, simple && style.simple)}>
                <Typography color="light" size="s">
                    <IMRComponent code={imr?.code} date_of_preparation={imr?.date_of_preparation} />
                </Typography>
            </div>
        </SectionImpression>
    ) : (
        <SectionImpression name={"IMR"} position={1}>
            <div data-test-id="Shell.Body.iMR" className={classnames(style.imr, marginXL && style["imr-marginXl"])}>
                <Typography color="light" size="s">
                    <IMRComponent code={imr?.code} date_of_preparation={imr?.date_of_preparation} />
                </Typography>
            </div>
        </SectionImpression>
    );
};

export default FullIMRComponent;
